import {
  PlanForecastFragment,
  PlanItemFragment,
  PlanShipmentFragment,
  useLazyGetForecastsQuery,
  useLazyGetPlanItemsQuery,
  useLazyGetShipmentsQuery,
} from '@/core/api/graphql/forshawGraphqlApi.generated.ts'
import { useCallback } from 'react'

const useGetPlanItemsForecastsShipments = () => {
  const [getPlanItemsQuery] = useLazyGetPlanItemsQuery()
  const [getShipmentsQuery] = useLazyGetShipmentsQuery()
  const [getForecastsQuery] = useLazyGetForecastsQuery()

  const getPlanItemsForecastsShipments = useCallback(
    async ({
      branchId,
      fromMonth,
      toMonth,
      productIds,
    }: {
      branchId: number
      fromMonth: string
      toMonth: string
      productIds?: number[]
    }): Promise<{
      planItems: PlanItemFragment[]
      shipments: PlanShipmentFragment[]
      forecasts: PlanForecastFragment[]
    }> => {
      const planItems: PlanItemFragment[] = []
      const shipments: PlanShipmentFragment[] = []
      const forecasts: PlanForecastFragment[] = []

      const planItemsData = await getPlanItemsQuery({
        branchId,
        fromMonth,
        toMonth,
        productIds,
      }).unwrap()

      if (planItemsData) {
        planItems.push(...planItemsData.planItems)
      }

      const shipmentsData = await getShipmentsQuery({
        branchId,
        fromMonth,
        toMonth,
        productIds,
      }).unwrap()

      if (shipmentsData) {
        shipments.push(...shipmentsData.shipments)
      }

      const forecastsData = await getForecastsQuery({
        branchId,
        fromMonth,
        toMonth,
        productIds,
      }).unwrap()

      if (forecastsData) {
        forecasts.push(...forecastsData.forecasts)
      }

      return { planItems, shipments, forecasts }
    },
    [getForecastsQuery, getPlanItemsQuery, getShipmentsQuery],
  )

  return { getPlanItemsForecastsShipments }
}

export { useGetPlanItemsForecastsShipments }
